<!-- TODO Ionic removal: think about using a card component here instead of ui-section -->
<ui-section class="width-100 height-100">
    <ui-section-content>
        <div class="title-row">
            <edit-text [disabled]="!(tileConfig.hasTileAdminAccess$ | async)" [(ngModel)]="tile.name" (ngModelChange)="updateTileName()" />
        </div>
        <div class="grid-container grid-1 large-margin-top">
            @for (sensorDescription of tile.description.sensors; track sensorDescription) {
                <div class="line">
                    @if (sensorDescription.sensorIdentifier | sensor; as sensor) {
                        <div class="sensor-name word-wrap flex-grow">{{ sensor.name }}</div>
                        @if (getSensorParamToDisplay(sensorDescription); as paramToDisplay) {
                            <div
                                class="sensor-state"
                                [ngClass]="paramToDisplay.value ? 'value' : 'missing-value'"
                                [ngStyle]="{ color: paramToDisplay.color }"
                            >
                                {{ paramToDisplay.value }}
                            </div>
                        }
                    }
                </div>
            }
        </div>
    </ui-section-content>
</ui-section>
